﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const styles = require("./VehicleIdentifier.scss");
class VehicleIdentifier extends React.Component {
    render() {
        return (React.createElement("div", { className: styles.chip },
            React.createElement("div", { className: styles.chip },
                React.createElement("div", { className: styles.embedChip }, this.props.sideCode)),
            this.props.plate));
    }
}
exports.VehicleIdentifier = VehicleIdentifier;
//# sourceMappingURL=VehicleIdentifier.js.map